import { render } from "./LoginCarousel.vue?vue&type=template&id=3864346c&scoped=true"
import script from "./LoginCarousel.vue?vue&type=script&lang=js"
export * from "./LoginCarousel.vue?vue&type=script&lang=js"

import "./LoginCarousel.vue?vue&type=style&index=0&id=3864346c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3864346c"]])

export default __exports__